// 简化的多钱包连接工具函数

// 检查是否支持 MetaMask
export function isMetaMaskAvailable() {
  return typeof window !== 'undefined' && window.ethereum && window.ethereum.isMetaMask
}

// 检查是否有以太坊钱包
export function isEthereumWalletAvailable() {
  return typeof window !== 'undefined' && window.ethereum
}

// 检查可用的钱包类型
export function getAvailableWallets() {
  const wallets = []
  
  if (window.ethereum) {
    if (window.ethereum.isMetaMask) wallets.push('MetaMask')
    else if (window.ethereum.isTrust) wallets.push('Trust Wallet')
    else if (window.ethereum.isCoinbaseWallet) wallets.push('Coinbase Wallet')
    else wallets.push('以太坊钱包')
  }
  
  if (window.okxwallet) wallets.push('OKX Wallet')
  if (window.BinanceChain) wallets.push('Binance Wallet')
  if (window.solana && window.solana.isPhantom) wallets.push('Phantom')
  if (window.tronWeb) wallets.push('TronLink')
  
  return wallets
}

// 简单的MetaMask连接函数（保持向后兼容）
export async function connectMetaMask() {
  if (!window.ethereum || !window.ethereum.isMetaMask) {
    throw new Error('请安装 MetaMask 钱包')
  }

  try {
    const accounts = await window.ethereum.request({
      method: 'eth_requestAccounts'
    })

    if (accounts.length === 0) {
      throw new Error('未找到钱包账户')
    }

    const address = accounts[0]
    const chainId = await window.ethereum.request({
      method: 'eth_chainId'
    })

    return {
      address,
      chainId,
      addressType: getAddressTypeByChainId(chainId)
    }
  } catch (error) {
    if (error.code === 4001) {
      throw new Error('用户拒绝了连接请求')
    }
    throw error
  }
}

// 根据链 ID 获取地址类型
function getAddressTypeByChainId(chainId) {
  const chainIdNum = parseInt(chainId, 16)
  
  switch (chainIdNum) {
    case 1: // Ethereum Mainnet
    case 5: // Goerli Testnet
    case 11155111: // Sepolia Testnet
      return 0 // ERC20
    case 56: // BSC Mainnet
    case 97: // BSC Testnet
      return 2 // BEP20
    default:
      return 0 // 默认 ERC20
  }
}

// 获取网络名称
export function getNetworkName(chainId) {
  const chainIdNum = parseInt(chainId, 16)
  
  const networks = {
    1: 'Ethereum Mainnet',
    5: 'Goerli Testnet',
    11155111: 'Sepolia Testnet',
    56: 'BSC Mainnet',
    97: 'BSC Testnet'
  }
  
  return networks[chainIdNum] || `Unknown Network (${chainIdNum})`
}

// 格式化钱包地址显示
export function formatAddress(address, startLength = 6, endLength = 4) {
  if (!address) return ''
  if (address.length <= startLength + endLength) return address
  
  return `${address.slice(0, startLength)}...${address.slice(-endLength)}`
}

// 验证以太坊地址格式
export function isValidEthereumAddress(address) {
  return /^0x[a-fA-F0-9]{40}$/.test(address)
}

// 监听钱包账户变化
export function watchAccountChange(callback) {
  if (!isMetaMaskAvailable()) return

  window.ethereum.on('accountsChanged', (accounts) => {
    callback(accounts.length > 0 ? accounts[0] : null)
  })
}

// 监听网络变化
export function watchNetworkChange(callback) {
  if (!isMetaMaskAvailable()) return

  window.ethereum.on('chainChanged', (chainId) => {
    callback(chainId)
  })
}
